class PlpFaqData extends HTMLElement {
  constructor() {
    super();
    this.questionsContent = this.querySelectorAll('.accordion__title');
    this.answersContent = this.querySelectorAll('.accordion__content');
    
    this.handleCollection = this.dataset.handleCollection;
  }

  connectedCallback() {
    this.fetchData();
  }

  async fetchData() {
    if(this.handleCollection === undefined || this.handleCollection === '') return;
    try {
      const response = await fetch(`https://api.wordlift.io/data/https/${window.location.host}/collections/${this.handleCollection}`);
  
      if (!response.ok) {
        throw new Error(`Errore HTTP: ${response.status}`);
      }
      // Parse JSON response
      const data = await response.json();

      //find mainEntity data
      let d = data.filter(i => {
        if(i.hasOwnProperty('mainEntity')) {
          return i;
        }
      })

      if (!d[0] || !d[0].mainEntity) {
        console.warn('PlpFaqData.fetchData: No FAQs found for handleCollection=', this.handleCollection);
        this.style.display = "none";
        return;
      } 
 
      this.renderProducts(d);
      this.insertJsonLd(d);
      
    } catch (error) {
      this.style.display = "none";
      console.error("Errore nella fetch:", error);
    }
  }
  
  insertJsonLd(faqData) {
    if (!faqData || !faqData.mainEntity) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData[0].mainEntity || []
    });
    document.head.appendChild(script);
  }

  renderProducts(faqData) {
    if (!faqData[0] || !faqData[0].mainEntity) return;
    const answers = faqData[0].mainEntity;
    answers.forEach((answer, i) => {
      this.questionsContent[i].innerHTML = answer.name;
      this.answersContent[i].innerHTML = answer.acceptedAnswer.text;
    });

    // Hide empty accordion block
    this.answersContent.forEach((el, i) => {
      if(this.answersContent[i].innerHTML.trim() === "") {
        this.answersContent[i].closest('.accordion').classList.add('tw-hidden')
      }
    })
  }
}

customElements.define('plp-faq-data', PlpFaqData);